import { render } from "./InputBox.vue?vue&type=template&id=851b0e98&scoped=true"
import script from "./InputBox.vue?vue&type=script&lang=js"
export * from "./InputBox.vue?vue&type=script&lang=js"

import "./InputBox.vue?vue&type=style&index=0&id=851b0e98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851b0e98"]])

export default __exports__